/* sp-arrival-guide v1 — 2026-08-03
 * The 12x arrival gap: guided arrivals reach cart at 37.6%, naked deep-links at
 * 3.0% (~85/day, 82% mobile, 88% one-page bounce). Someone taps a TikTok/IG/FB
 * link, lands on ONE diamond's page with zero paths sideways, and leaves.
 * Fix: on a BARE first-page arrival to a diamond PDP, offer a dismissible
 * bottom card seeded with the stone they landed on — one tap to the guided
 * catalog (same shape, similar carat) or to ring styles. Additive; delete to revert.
 */
(function () {
  'use strict';
  if (window.SPJ_DISABLED) return;
  if (window.__SPJ_AG__) return;
  window.__SPJ_AG__ = 1;

  var COLLECT = 'https://zkvdtxlhzucquktwyrjw.supabase.co/functions/v1/collect';
  var AUTH = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InprdmR0eGxoenVjcXVrdHd5cmp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMzcwODMsImV4cCI6MjEwMDkxMzA4M30.T6p6Z4_URBOQHm8kLZXEhVUEf_xAZUk2_t7HpYI1shg';
  var WRITE_KEY = 'sjp_wk_9f27c1e84ab35d60';
  // verified catalog filter values only (Moval confirmed live; must sort
  // before Oval — word-boundary match still needs the longer name first)
  var SHAPES = ['Round', 'Princess', 'Cushion', 'Moval', 'Oval', 'Emerald', 'Pear', 'Marquise', 'Asscher', 'Radiant'];

  // ---- first-page marker: set on every page, checked before it's set ----
  var firstPage = false;
  try {
    firstPage = !sessionStorage.getItem('spj_ag_nav');
    sessionStorage.setItem('spj_ag_nav', '1');
  } catch (err) {}

  var isDiamondPdp = /^\/products\/diamonds(?:\/|$)/.test(location.pathname) && /[?&]sku=/.test(location.search);
  if (!isDiamondPdp || !firstPage) return;

  // instrumented shares are gift links — never interrupt those
  if (/[?&]sref=/.test(location.search)) return;
  // builder context: they came from the ring flow, not a cold link
  if (/(?:^|;\s*)_ring=/.test(document.cookie)) return;
  // referred by our own site = not a bare arrival
  try {
    if (document.referrer && new URL(document.referrer).host === location.host) return;
  } catch (err) {}
  var shown = null;
  try { shown = sessionStorage.getItem('spj_ag_shown'); } catch (err) {}
  if (shown) return;

  function track(name, props) {
    try {
      var m = document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/);
      fetch(COLLECT, {
        method: 'POST',
        keepalive: true,
        headers: { 'content-type': 'application/json', 'Authorization': AUTH },
        body: JSON.stringify({
          k: WRITE_KEY,
          events: [{ event_id: (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : null, ts: Date.now(), visitor_id: m ? decodeURIComponent(m[1]).slice(0, 64) : null, name: name, source: 'theme', page_type: 'diamond_pdp', page_path: location.pathname + location.search, props: props || {} }]
        })
      }).catch(function () {});
    } catch (err) {}
  }

  function seed() {
    // per-stone specs live in the H1 (the <title> is generic on this template)
    var h1 = document.querySelector('h1');
    var txt = h1 ? h1.textContent : '';
    var cm = txt.match(/([\d.]+)\s*Carat/i);
    var carat = cm ? parseFloat(cm[1]) : null;
    var shape = null;
    for (var i = 0; i < SHAPES.length; i++) {
      if (new RegExp('\\b' + SHAPES[i] + '\\b', 'i').test(txt)) { shape = SHAPES[i]; break; }
    }
    return { carat: carat && isFinite(carat) ? carat : null, shape: shape };
  }

  // interaction-idle tracking: never materialize the card under a moving thumb
  var lastTouch = 0;
  ['scroll', 'touchstart', 'touchmove'].forEach(function (t) {
    window.addEventListener(t, function () { lastTouch = Date.now(); }, { passive: true });
  });

  var seedTries = 0;
  function show() {
    if (document.querySelector('.spj-ag')) return;
    if (window.__SPJ_SU_ACTIVE || document.querySelector('.spj-su')) return; // dead-stone card owns this page
    if (document.querySelector('.spj-sr--slide')) return; // never stack on the save-ring card
    if ((window.scrollY || 0) > window.innerHeight * 1.5) return; // already deep = already engaged
    if (Date.now() - lastTouch < 600) { setTimeout(show, 700); return; } // wait for an idle moment
    var s = seed();
    if (!s.carat && seedTries < 8) { seedTries++; setTimeout(show, 500); return; } // H1 may still be hydrating
    var catalogUrl = '/collections/lab-diamonds';
    var label = 'Explore all lab diamonds';
    if (s.shape && s.carat) {
      var lo = Math.max(0.5, Math.round((s.carat - 0.4) * 10) / 10);
      if (lo > s.carat) lo = Math.floor(s.carat * 10) / 10; // band must include the landed stone
      var hi = Math.round((s.carat + 0.6) * 10) / 10;
      catalogUrl += '?shape=' + s.shape + '&caratMin=' + lo + '&caratMax=' + hi;
      label = 'See all ' + s.shape + ' diamonds ' + lo + '–' + hi + ' ct';
    } else if (s.shape) {
      catalogUrl += '?shape=' + s.shape;
      label = 'See all ' + s.shape + ' diamonds';
    }

    var css = document.createElement('style');
    css.id = 'spj-ag-css';
    css.textContent =
      '.spj-ag{position:fixed;left:16px;right:16px;bottom:16px;z-index:9997;max-width:430px;margin:0 auto;background:#fff;border:1px solid #e3e6ea;border-radius:10px;padding:14px 16px;box-shadow:0 8px 30px rgba(10,29,46,.16);transform:translateY(8px);opacity:0;pointer-events:none;transition:transform .3s ease,opacity .3s ease}' +
      '.spj-ag.spj-ag--in{transform:none;opacity:1;pointer-events:auto}' +
      '.spj-ag__h{font-weight:600;font-size:14px;color:#0A1D2E;margin:0 0 10px;padding-right:34px}' +
      '.spj-ag__x{position:absolute;top:0;right:0;border:0;background:none;font-size:16px;color:#8a94a0;cursor:pointer;padding:14px 14px 10px 10px}' +
      '@media (max-height:640px){.spj-ag{padding:10px 12px}.spj-ag__a{padding:9px 10px}}' +
      '.spj-ag__a{display:block;text-align:center;border-radius:7px;padding:11px 12px;font-size:13px;font-weight:600;text-decoration:none;margin-top:8px}' +
      '.spj-ag__a--main{background:#0A1D2E;color:#fff}' +
      '.spj-ag__a--alt{color:#0A1D2E;border:1px solid #cfd5db;background:#fff}' +
      '@media (prefers-reduced-motion:reduce){.spj-ag{transition:none}}';
    document.head.appendChild(css);

    var bar = document.createElement('div');
    bar.className = 'spj-ag';
    bar.setAttribute('role', 'dialog');
    bar.setAttribute('aria-label', 'Explore more diamonds');
    bar.innerHTML =
      '<button type="button" class="spj-ag__x" aria-label="Dismiss">✕</button>' +
      '<p class="spj-ag__h">Like this one? There’s a whole tray to compare.</p>' +
      '<a class="spj-ag__a spj-ag__a--main" href="' + catalogUrl + '">' + label + ' →</a>' +
      '<a class="spj-ag__a spj-ag__a--alt" href="/collections/engagement-rings">Browse ring styles first</a>';
    document.body.appendChild(bar);
    requestAnimationFrame(function () { requestAnimationFrame(function () { bar.classList.add('spj-ag--in'); }); });

    try { sessionStorage.setItem('spj_ag_shown', '1'); } catch (err) {}
    track('arrival_guide_shown', { shape: s.shape, carat: s.carat, seeded: !!(s.shape && s.carat) });

    bar.querySelector('.spj-ag__x').addEventListener('click', function () {
      bar.remove();
      track('arrival_guide_dismissed', {});
    });
    bar.querySelectorAll('.spj-ag__a').forEach(function (a) {
      a.addEventListener('click', function () {
        track('arrival_guide_click', { target: a.className.indexOf('main') !== -1 ? 'catalog' : 'settings' });
        bar.remove(); // don't reappear stale from bfcache when they come back
      });
    });
    window.addEventListener('pagehide', function () { bar.remove(); });

    // stop competing with real engagement: quietly leave once they go deep
    var onScroll = function () {
      if ((window.scrollY || 0) > window.innerHeight * 1.5) {
        bar.remove();
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // let the stone render first — the guide is a nudge, not a gate
  function arm() { setTimeout(show, 3500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
